import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import NavHeader from './navheader'
import Footer from './footer'
import SubMenu from './submenu'
import MetaTags from 'react-meta-tags'

class PrivacyPolicy extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        // console.log('metatag')

        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className="container main-bg">
                    <MetaTags>
                        <title>{'ส่งสด - บริการส่งของสดจากตลาด'}</title>
                        <meta property="og:title" content={'ส่งสด บริการส่งของสด'} />
                        <meta property="og:url" content={window.location.href} />
                        <meta property="og:image" content={'imgsrc'} />
                        <meta property="og:description" content={'บริการส่งของสดจาก ตลาดยิ่งเจริญ ที่คัดสรรคุณภาพของวัตถุดิบโดยผู้ซื้อสินค้าส่วนตัว'} />
                        <meta property="og:type" content='website' />
                        <meta property="fb:pages" content="129193147647837" />
                    </MetaTags>
                    <div className='container'>
                        <div className="row" style={{ backgroundColor: '#fafafa' }}>
                            <Col style={{ paddingLeft: 50 }}>
                                <h2 style={{ paddingLeft: 30, paddingTop: 20 }}>นโยบายความเป็นส่วนตัว</h2>
                            </Col>
                        </div>
                    </div>

                    <div className='container'>
                        <Col style={{ paddingLeft: 50, paddingRight: 50 }}>
                            <p>บริษัท ยิ่งเจริญ เฟรชเมท จำกัด (“บริษัทฯ”) ผู้ให้บริการขายและจัดส่งสินค้าจากตลาด ผ่านแพลตฟอร์ม ส่งสด.com (songsod.com) (“ส่งสด”) ทางบริษัทฯจำเป็นต้องเก็บรวบรวมข้อมูลและใช้ข้อมูลที่จำเป็นเพื่อระบุถึงตัวบุคคลตาม พรบ.คอมพิวเตอร์ แห่งราชอาณาจักรไทยเท่านั้น</p>
                            <p>ทางบริษัทฯจะเก็บรักษาข้อมูลของท่านไว้เป็นระยะเวลาตราบเท่าที่กฎหมายกำหนดหรือ เป็นระยะเวลาตามวัตถุประสงค์ในการเก็บข้อมูลนั้นๆ ท่านสามารถเยี่ยมชมและท่องเว็บไซต์ส่งสดได้โดยไม่จำเป็นต้องให้ข้อมูลส่วนบุคคลใดๆ</p>
                            <br />
                            <h4 style={{ paddingLeft: 30 }}>การเก็บข้อมูล</h4>
                            <p style={{ textAlign: 'center' }}>เมื่อท่านสร้างบัญชีผู้ใช้กับทางส่งสด ข้อมูลที่บริษัทฯ รวบรวมเก็บไว้อาจมีดังต่อไปนี้</p>
                            <p>• ชื่อ - นามสกุล</p>
                            <p>• อีเมล</p>
                            <p>• เบอร์โทรศัพท์</p>
                            <p>• ข้อมูลที่อยู่จัดส่ง</p>
                            <p>• พิกัดแผนที่จัดส่ง</p>
                            <br />
                            <h4 style={{ paddingLeft: 30 }}>บริษัทฯ เก็บข้อมูลของท่านเพื่อ</h4>
                            <p>• เพื่อการจัดส่งสินค้าที่ท่านสั่งซื้อ</p>
                            <p>• เพื่อให้ข้อมูลสินค้า</p>
                            <p>• เพื่อการให้บริการต่างๆของทางบริษัทฯ</p>
                            <p>• แก้ปัญหาความขัดแย้ง ข้อพิพาท ที่เกิดขึ้น</p>
                            <br />
                            <h4 style={{ paddingLeft: 30 }}>ความยินยอม</h4>
                            <p>การที่คุณใช้เว็บไซต์ต่อ คุณได้ยินยอมให้ดำเนินการในข้อมูลส่วนบุคคลของคุณตามนโยบายความเป็นส่วนตัว ข้อกำหนดและเงื่อนไข และข้อตกลงของผู้ขายของบริษัทฯ แล้ว</p>
                            <br />
                            <h4 style={{ paddingLeft: 30 }}>การเปลี่ยนแปลงแก้ไขนโยบายความเป็นส่วนตัว</h4>
                            <p>บริษัทฯ สงวนสิทธิ์ในการปรับและเปลี่ยนนโยบายความเป็นส่วนตัวได้ทุกเมื่อ นโยบายที่มีการเปลี่ยนแปลง จะประกาศบนเว็บไซต์ของเรา คุณควรตรวจสอบนโยบายนี้ทุกครั้งที่คุณเข้าเว็บไซต์ของเราเพื่อที่จะได้รับรู้ถึงนโยบายฉบับล่าสุดที่มีผลบังคับใช้</p>
                            <br />
                            <br />
                        </Col>
                    </div>
                </div>
                <Footer />
            </div >
        )
    }
}

export default PrivacyPolicy


// WEBPACK FOOTER //
// ./src/components/page_privacy_policy.js